import React, { useState, useEffect } from "react";
import DropdownValues from "../Student/Reusablecomponents/DropDownValues";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { SelectLanguageData } from "../Redux/Reducers/Common/Language";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import html2canvas from "html2canvas";

export function QBSubjectnames(e) {
  if (e === "1") {
    return "Mathematics";
  } else if (e === "3") {
    return "English";
  }else if (e === "4") {
    return "Hindi";
  }
  else if (e === "5") {
    return "Telugu";
  }
   else {
    return "Science";
  }
}

export function SubjectIds(e) {
  if (e == "Mathematics") {
    return 1;
  } else if (e == "English") {
    return 3;
  } else if (e == "Hindi") {
    return 4;
  }
  else if (e == "Telugu") {
    return 5;
  }
   else {
    return 2;
  }
}

export function ClearSession() {
  if (
    parseInt(process.env.REACT_APP_WholeSESSIONTIMEOUT) <
    (new Date().getTime() -
      new Date(localStorage.getItem("Clearstorage")).getTime()) /
      (1000 * 60)
  ) {
    sessionStorage.clear();
    localStorage.clear();
    // navigate("/Login");
    window.location.reload();
  }
}

export function TabViewValues(props) {
  return (
    <>
      <div className="Tabs-Align">
        {props.Tabs?.map((tab, index) => (
          <div
            key={index}
            onClick={() => props.onClick(tab.Value)}
            className={
              props.Selectedtab === tab.Value ? "Activetab" : "Inactivetab"
            }
          >
            {tab.Name}
          </div>
        ))}
      </div>
    </>
  );
}

// export function Languages(props) {
//   const Options = [
//     { display: "Hindi", value: "hi" },
//     // { display:"Telugu",value:"te" }
//   ];
//   return (
//     <DropdownValues
//       className="NCLDropdown"
//       options={Options}
//       onChange={(e) => props.onChange(e.target.value)}
//     />
//   );
// }

export function Languages(props) {
  const dispatch = useDispatch();
  const SLanguageId = useSelector(
    (state) => state.SelectLanguageData.SLanguage
  );
  const [LOptions, SetLOptions] = useState();

  const GetLanguages = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=0&LovCategoryId=69&ParentLovId=0`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Data = Array.from(
          res.data
            .reduce(
              (map, item) =>
                map.set(item.lovId, {
                  display: item.lovName,
                  value: item.lovId,
                }),
              new Map()
            )
            .values()
        );
        const GetEnglish = Data.filter((item) => item.display === "English");

        dispatch(
          SelectLanguageData({
            SLanguage: SLanguageId || GetEnglish?.[0]?.value.toString(),
          })
        );
        SetLOptions(Data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    // GetLanguages();
  }, []);
  return (
    <DropdownValues
      className="NCLDropdown"
      selectoption={SLanguageId}
      options={JSON.parse(localStorage.getItem("LanguageOptions"))}
      // options={LOptions}
      onChange={(e) => props.onChange(e.target.value)}
      labelname={props.labelname}
      disabled={false}
    />
  );
}

export function CheckLanguage(LId) {
  const LOptions = JSON.parse(localStorage.getItem("LanguageOptions"));
  const GetSubject = LOptions?.filter((item) => item.value === LId);
  if (GetSubject?.[0]?.display === "Hindi") {
    return true;
  } else {
    return false;
  }
}

// Input Based questions validations for QB
export function InputType(Value) {
  switch (Value) {
    case "T":
      return "text";
    case "F":
      return "text";
    default:
      return "number";
  }
}

// Below is downloadXL for common
export function DownloadExcel(
  data,
  fileName,
  multipleSheets,
  sheetName,
  Heading,
  AFilter
) {
  const EXCEL_TYPE =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

  const createWorkbook = async () => {
    const workbook = new ExcelJS.Workbook();

    if (multipleSheets) {
      data.forEach((item) => {
        const { sheetName, details } = item;
        const worksheet = workbook.addWorksheet(sheetName);
        if (details.length > 0) {
          const columns = Object.keys(details[0]).map((key) => ({
            header: key,
            key: key,
            width: key.length < 20 ? 20 : key.length,
          }));
          worksheet.columns = columns;
          if (Heading) {
          worksheet.mergeCells(1, 1, 2, columns.length);
          worksheet.getCell(2, 1).value = Heading;
          worksheet.getCell("A1").alignment = {
            // horizontal: "center",
            vertical: "middle",
          };
          worksheet.getRow(1).font = { bold: true };
          // Add a new row for the column headers
          worksheet.getRow(1).eachCell((cell) => {
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "95b3d7" },
            };
          });
          const columnHeaders = columns.map((column) => column.header);
          worksheet.addRow(columnHeaders);
          worksheet.getRow(3).font = { bold: true };
          // if (AFilter) {
          //   worksheet.autoFilter = {
          //     from: "A3",
          //     to: `${String.fromCharCode(64 + columns.length)}3`,
          //   };
          //   if (worksheet.length > 0) {
          //     const filterRange = {
          //       from: `${worksheet[0]}1`,
          //       to: `${worksheet[worksheet.length - 1]}1`,
          //     };
          //     worksheet.autoFilter = filterRange;
          //   }
          // }
        } else {
          worksheet.getRow(1).font = { bold: true };
        }
          details.forEach((row) => worksheet.addRow(row));
          worksheet.eachRow((row, rowNumber) => {
          row.eachCell((cell, colNumber) => {
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
          });
        });
          worksheet.getRow(1).font = { bold: true };
        }
      });
    } else {
      const worksheet = workbook.addWorksheet(sheetName);

      if (data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          header: key,
          key: key,
          width: key.length + 5,
        }));
        worksheet.columns = columns;
        if (Heading) {
          worksheet.mergeCells(1, 1, 2, columns.length);
          worksheet.getCell(2, 1).value = Heading;
          worksheet.getCell("A1").alignment = {
            horizontal: "center",
            vertical: "middle",
          };
          worksheet.getRow(1).font = { bold: true };
          // Add a new row for the column headers
          worksheet.getRow(1).eachCell((cell) => {
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "95b3d7" },
            };
          });
          const columnHeaders = columns.map((column) => column.header);
          worksheet.addRow(columnHeaders);
          worksheet.getRow(3).font = { bold: true };
          if (AFilter) {
            worksheet.autoFilter = {
              from: "A3",
              to: `${String.fromCharCode(64 + columns.length)}3`,
            };
            if (worksheet.length > 0) {
              const filterRange = {
                from: `${worksheet[0]}1`,
                to: `${worksheet[worksheet.length - 1]}1`,
              };
              worksheet.autoFilter = filterRange;
            }
          }
        } else {
          worksheet.getRow(1).font = { bold: true };
        }

        data.forEach((row) => worksheet.addRow(row));
        worksheet.eachRow((row, rowNumber) => {
          row.eachCell((cell, colNumber) => {
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
          });
        });
      }
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: EXCEL_TYPE });
    saveAs(blob, `${fileName}.xlsx`);
  };

  createWorkbook();
}
// Above is downloadXL for common
// export function DownloadGraphImage(ChartData, FIleName) {
//   const chart = ChartData.current;
//   if (!chart) return;
  
//   const canvas = chart.canvas;
//   const ctx = canvas.getContext("2d");
  
//   // Save current state
//   ctx.save();
//   // alert("inside function")

//   // Draw white background
//   ctx.globalCompositeOperation = "destination-over";
//   ctx.fillStyle = "white";
//   ctx.fillRect(0, 0, canvas.width, canvas.height);

//   // Export to image
//   const url = canvas.toDataURL("image/png");

//   const link = document.createElement("a");
//   link.href = url;
//   link.download = `${FIleName}.png`;
//   link.click();

//   // Restore to original state
//   ctx.restore();
// }
// Below is download graph image working
// export function DownloadGraphImage(ChartData, FileName) {
//   const chart = ChartData.current;
//   if (!chart) return;

//   const canvas = chart.canvas;
//   const ctx = canvas.getContext("2d");

//   // Create a new temporary canvas with extra space for title
//   const tempCanvas = document.createElement("canvas");
//   const paddingTop = 50;
//   tempCanvas.width = canvas.width;
//   tempCanvas.height = canvas.height + paddingTop;

//   const tempCtx = tempCanvas.getContext("2d");

//   // White background
//   tempCtx.fillStyle = "white";
//   tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);

//   // Draw title at top center
//   tempCtx.fillStyle = "black";
//   tempCtx.font = "bold 22px Arial";
//   tempCtx.textAlign = "center";
//   tempCtx.textBaseline = "top";
//   tempCtx.fillText(FileName, tempCanvas.width / 2, 10);

//   // Draw original chart below the title
//   tempCtx.drawImage(canvas, 0, paddingTop);

//   // Export to image
//   const url = tempCanvas.toDataURL("image/png");
//   const link = document.createElement("a");
//   link.href = url;
//   link.download = `${FileName}.png`;
//   link.click();
// }
// Above is download graph image working
export function DownloadGraphImage(ChartData, FileName) {
  const chart = ChartData.current;
  if (!chart) return;

  const canvas = chart.canvas;
  const ctx = canvas.getContext("2d");

  // Create temporary canvas
  const tempCanvas = document.createElement("canvas");
  const tempCtx = tempCanvas.getContext("2d");

  // Set title style for measurement
  const fontSize = 22;
  const lineHeight = fontSize + 10;
  const maxWidth = canvas.width * 0.9;
  tempCtx.font = `bold ${fontSize}px Arial`;

  // Split title into lines if too long
  const words = FileName.split(" ");
  const lines = [];
  let currentLine = "";

  for (let word of words) {
    const testLine = currentLine ? `${currentLine} ${word}` : word;
    const { width } = tempCtx.measureText(testLine);
    if (width > maxWidth && currentLine) {
      lines.push(currentLine);
      currentLine = word;
    } else {
      currentLine = testLine;
    }
  }
  if (currentLine) lines.push(currentLine);

  // Calculate dynamic padding based on title height
  const paddingTop = lines.length * lineHeight + 20;

  tempCanvas.width = canvas.width;
  tempCanvas.height = canvas.height + paddingTop;

  // Fill white background
  tempCtx.fillStyle = "white";
  tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);

  // Draw title lines
  tempCtx.fillStyle = "black";
  tempCtx.font = `bold ${fontSize}px Arial`;
  tempCtx.textAlign = "center";
  tempCtx.textBaseline = "top";

  lines.forEach((line, i) => {
    tempCtx.fillText(line, tempCanvas.width / 2, 10 + i * lineHeight);
  });

  // Draw the original chart below the title
  tempCtx.drawImage(canvas, 0, paddingTop);

  // Export as image
  const url = tempCanvas.toDataURL("image/png");
  const link = document.createElement("a");
  link.href = url;
  link.download = `${FileName}.png`;
  link.click();
}


export async function DownloadHTMlcodeimage(Ref,Filename) {
   const element = Ref?.current;
  if (!element) return;

  try {
    const canvas = await html2canvas(element, {
      useCORS: true,
      backgroundColor: "#fff",
      scale: 2,
    });

    const image = canvas.toDataURL("image/png");

    const link = document.createElement("a");
    link.href = image;
    link.download = `${Filename}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading image:", error);
  }
}

export function Testcolors(e){
  switch(e){
    case 1 : return "#347463";
    case 2 : return "#b273c9";
    case 3 : return "#fa897b";
  }
}
export function NCAssessmentName(e) {
  const types = {
    1: "SODHANA Assessment",
    2: "SADHANA Assessment",
    3: "SAMAGRA Assessment",
  };

  return types[e] || "";
}